import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';
import { ApiResponse } from './types/common';
import { PortfolioGame, UnderwritingChartsApiResponse } from './types/underwriting';

const user = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCharts: builder.query<any, any>({
      query: (submoduleId) => apiRoutes.charts(submoduleId),
    }),
    getChartById: builder.query<any, any>({
      query: ({ submoduleId, chartId, queryParams }) =>
        apiRoutes.chartById(submoduleId, chartId, queryParams),
    }),
    downloadChartCsv: builder.query<any, any>({
      query: ({ submoduleId, chartId, queryParams }) =>
        apiRoutes.chartCsvDownload(submoduleId, chartId, queryParams),
    }),
    downloadDealCashflow: builder.query<
      ApiResponse<string>,
      { submoduleId: string; gameId?: string; cohort?: string; fundingMonth?: string }
    >({
      query: ({ submoduleId, gameId, cohort, fundingMonth }) => ({
        url: apiRoutes.dealCashflowDownload(submoduleId),
        params: {
          ...(gameId && { gameId }),
          ...(cohort && { cohort }),
          ...(fundingMonth && { fundingMonth }),
        },
      }),
    }),

    downloadFinancingPerformanceReportsCsv: builder.query<
      ApiResponse<{ url: string }>,
      { submoduleId: string; asOfMonth: string }
    >({
      query: ({ submoduleId, asOfMonth }) => {
        return {
          url: apiRoutes.downloadFinancingPerformanceReportsCsv(submoduleId),
          params: {
            as_of_month: asOfMonth,
          },
        };
      },
    }),

    getUnderwritingCharts: builder.query<UnderwritingChartsApiResponse, any>({
      query: ({ submoduleId, queryParams }) =>
        apiRoutes.underwritingCharts(submoduleId, queryParams),
    }),

    getPortfolioGames: builder.query<
      ApiResponse<PortfolioGame[]>,
      { submoduleId: string; gameId: string }
    >({
      query: ({ submoduleId, gameId }) => apiRoutes.portfolioGames(submoduleId, gameId),
    }),
  }),
});

export const {
  useLazyGetChartsQuery,
  useLazyGetChartByIdQuery,
  useLazyDownloadChartCsvQuery,
  useLazyDownloadDealCashflowQuery,
  useLazyGetUnderwritingChartsQuery,
  useLazyGetPortfolioGamesQuery,
  useLazyDownloadFinancingPerformanceReportsCsvQuery,
} = user;
